import "./Workcard.css"
import Workcard from "./Workcard";
import WorkCardData from "./WorkcardData"
import React from 'react'

const Work = () => {
  return (
    <div className="work-container">
        <h1 className="project-heading">Projects</h1>
        <div className="project-container">
            {WorkCardData.map((val,i)=>{
                return(
                    <Workcard
                    key={i}
                    imgsrc={val.imgsrc}
                    title={val.title} text={val.text}
                    view={val.view}
                    />
                )
            })}
            
        </div>
    </div>
  )
}

export default Work